import { configureStore } from '@reduxjs/toolkit';
import { edosApi } from './edosApi';
import { authApi } from './authApi';
import { cartApi } from './cartApi';
import { bookingsApi } from './bookingsApi';
import { reportsApi } from './reportsApi';
import { testimonialsApi } from './testimonialsApi';
import { supportApi } from './supportApi';
import { siteContentApi } from './siteContentApi';
import { notificationsApi } from './notificationsApi';
import { salesApi } from './salesApi';
import { queriesApi } from './queriesApi';
import { capaApi } from './capaApi';
import { feedbackApi } from './feedbackApi';
import { portalTicketsApi } from './portalTicketsApi';
import { refDoctorsApi } from './refDoctorsApi';
import { tatReportApi } from './tatReportApi';
import { corporateApi } from './corporateApi';

export const store = configureStore({
  reducer: {
    [edosApi.reducerPath]: edosApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [cartApi.reducerPath]: cartApi.reducer,
    [bookingsApi.reducerPath]: bookingsApi.reducer,
    [reportsApi.reducerPath]: reportsApi.reducer,
    [testimonialsApi.reducerPath]: testimonialsApi.reducer,
    [supportApi.reducerPath]: supportApi.reducer,
    [siteContentApi.reducerPath]: siteContentApi.reducer,
    [notificationsApi.reducerPath]: notificationsApi.reducer,
    [salesApi.reducerPath]: salesApi.reducer,
    [queriesApi.reducerPath]: queriesApi.reducer,
    [capaApi.reducerPath]: capaApi.reducer,
    [feedbackApi.reducerPath]: feedbackApi.reducer,
    [portalTicketsApi.reducerPath]: portalTicketsApi.reducer,
    [refDoctorsApi.reducerPath]: refDoctorsApi.reducer,
    [tatReportApi.reducerPath]: tatReportApi.reducer,
    [corporateApi.reducerPath]: corporateApi.reducer,
  },
  middleware: (getDefault) =>
    getDefault().concat(
      edosApi.middleware,
      authApi.middleware,
      cartApi.middleware,
      bookingsApi.middleware,
      reportsApi.middleware,
      testimonialsApi.middleware,
      supportApi.middleware,
      siteContentApi.middleware,
      notificationsApi.middleware,
      salesApi.middleware,
      queriesApi.middleware,
      capaApi.middleware,
      feedbackApi.middleware,
      portalTicketsApi.middleware,
      refDoctorsApi.middleware,
      tatReportApi.middleware,
      corporateApi.middleware,
    ),
});

// setupListeners is NOT called: it is what enables refetchOnFocus and
// refetchOnReconnect, i.e. RTK Query re-hitting the API whenever a tab
// regains focus or the network returns. Those are automatic calls, and
// this app makes none.
// Enables refetchOnFocus / refetchOnReconnect behaviour
// setupListeners(store.dispatch);
